// Data loading for the Tablet/Mobile mega menu shells.
//
// This intentionally mirrors CardMenuList.vue's own menu_load()/filterHidden()/
// markSelectedByPath() logic (which itself duplicates NavSideBar.vue's copy —
// duplicating this small loader per consumer is the existing convention in this
// codebase, not something introduced here) so the desktop mega menu file never
// has to be touched. Per-item permission/lock logic (checkproductvalue) and all
// navigation stay inside SideBarMenu.vue, which every mega menu tier renders
// leaf items through — this file only decides which sections exist and in what
// order, exactly like CardMenuList.vue already does.
import _STARR_MENU_ from "@/components/Menu/STARR_Menu.js";
import _Board_MENU_ from "@/components/Menu/BoardPage_Menu.js";
import _Family_MENU_ from "@/components/Menu/FamilyMenu.js";

function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function filterHidden(items, productList) {
  return (items || [])
    .filter((item) => {
      if (item.hide) return false;
      if (item.product_gate && item.product_code && item.product_code.length) {
        return item.product_code.some((p) => productList.includes(p));
      }
      return true;
    })
    .map((item) => {
      if (item.children) item.children = filterHidden(item.children, productList);
      return item;
    });
}

function markSelectedByPath(data, path) {
  function traverse(node) {
    let matched = false;
    if (node.children && node.children.length > 0) {
      node.children = node.children.map((child) => {
        const result = traverse(child);
        if (result.matched) matched = true;
        return result.node;
      });
      node.is___select = matched ? true : null;
    } else if (node.to === path) {
      node.is___select = true;
      matched = true;
    } else {
      node.is___select = null;
    }
    return { node, matched };
  }
  return data.map((item) => traverse(item).node);
}

// Some menu datasets split one logical group into two adjacent top-level
// entries so desktop's flex-wrap layout can show them as side-by-side columns
// (e.g. BoardPage_Menu.js "Engage", or the FMS master lists) — the second
// entry carries has_children but no name/icon of its own. A blank card would
// look broken in the new card/rail UI, so fold its children into the
// preceding named entry instead. This changes nothing about what is
// reachable or how it's gated — only how these two already-adjacent entries
// are grouped for display.
function mergeNamelessSiblings(list) {
  const merged = [];
  (list || []).forEach((item) => {
    const hasLabel = item.name && item.name.trim().length;
    if (!hasLabel && item.has_children && merged.length) {
      const prev = merged[merged.length - 1];
      prev.children = [...(prev.children || []), ...(item.children || [])];
      return;
    }
    if (!hasLabel) return;
    merged.push(item);
  });
  return merged;
}

// Picks the same menu dataset CardMenuList.vue picks, using the identical
// precedence order (partner > family book > board > default STARR).
export function pickMenuDataset(is_board_page, is__family_page) {
  const isFamilyBook = localStorage.getItem("is_family_book") === "true";
  const isPartner = localStorage.getItem("domain") === "partner";
  if (isPartner) return _STARR_MENU_;
  if (isFamilyBook || is__family_page) return _Family_MENU_;
  if (is_board_page) return _Board_MENU_;
  return _STARR_MENU_;
}

export function buildMegaMenuSections(is_board_page, is__family_page, routePath) {
  const TempMenuObj = pickMenuDataset(is_board_page, is__family_page);
  const productList = (localStorage.getItem("tectalik_product_list") || "").split(",").filter(Boolean);
  const prepare = (list) =>
    mergeNamelessSiblings(
      markSelectedByPath(filterHidden(deepClone(list || []), productList), routePath)
    );
  return {
    topSections: prepare(TempMenuObj.TopMenuList),
    bottomSections: [...prepare(TempMenuObj.BottonLeftMenuList), ...prepare(TempMenuObj.BottonRightMenuList)],
  };
}

export function isMdiIcon(icon) {
  return typeof icon === "string" && icon.startsWith("mdi-");
}

export function svgIconUrl(item, color) {
  if (!item || !item.svg_icon) return null;
  const encoded = encodeURIComponent(item.svg_icon.replace(/__FLLL_Color__/g, color));
  return `data:image/svg+xml;utf8,${encoded}`;
}
